<script>
    import {Icon} from 'svelte-chota';
    import {mdiLoading} from '@mdi/js';
</script>

<div class="text-center text-grey">
    <span class="text-primary"><Icon src={mdiLoading} size=3 spin=1/></span>
</div>